import { render } from "./content-preview-container.vue?vue&type=template&id=1517ab4c&scoped=true"
import script from "./content-preview-container.vue?vue&type=script&lang=js"
export * from "./content-preview-container.vue?vue&type=script&lang=js"

import "./content-preview-container.vue?vue&type=style&index=0&id=1517ab4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1517ab4c"]])

export default __exports__